import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import HomePage2 from '../HomePage2/HomePage2';
import AboutPage from '../AboutPage/AboutPage';
import BecomeVolunteer from '../BecomeVolunteer/BecomeVolunteer';
import EventSinglePage from '../EventSinglePage/EventSinglePage';
import CausesPage from '../CausesPage/CausesPage';
import CausesSinglePage from '../CausesSinglePage/CausesSinglePage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectSingle from '../ProjectSingle/ProjectSingle';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import VolunteerPage from '../VolunteerPage/VolunteerPage';
import VolunteerPageS2 from '../VolunteerPageS2/VolunteerPageS2';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ShopPage from '../ShopPage'
import ProductSinglePage from '../ProductSinglePage';
import CartPage from '../CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import DonatePage from '../DonatePage/DonatePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import AdminLogin from '../AdminLogin/AdminLogin';
import AdminDashboard from '../AdminDashboard/AdminDashboard';
import AdminServiceEditor from '../AdminServiceEditor/AdminServiceEditor';
import AdminEventEditor from '../AdminEventEditor/AdminEventEditor';
import AdminBlogEditor from '../AdminBlogEditor/AdminBlogEditor';
import AdminVolunteerEditor from '../AdminVolunteerEditor/AdminVolunteerEditor';
import PeoplePage from '../CommitteePage/CommitteePage';
import WallOfAkhirah from '../WallOfAkhirah/WallOfAkhirah';
import Auth0ProviderWithNavigate from '../../components/Auth0Provider';
import ProtectedRoute from '../../components/ProtectedRoute';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <Routes>
            <Route path="/" element={<HomePage2 />} />
            <Route path="home" element={<HomePage2 />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="people" element={<PeoplePage />} />
            <Route path="become-volunteer" element={<BecomeVolunteer />} />
            <Route path="event-single/:slug" element={<EventSinglePage />} />
            <Route path="service-single/:slug" element={<ServiceSinglePage />} />
            <Route path="causes" element={<CausesPage />} />
            <Route path="causes-single/:slug" element={<CausesSinglePage />} />
            <Route path='blog' element={<BlogPage />} />
            <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
            <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
            <Route path='blog-single/:slug' element={<BlogDetails />} />
            <Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} />
            <Route path='blog-single-fullwidth/:slug' element={<BlogDetailsFull />} />
            <Route path="volunteer-1" element={<VolunteerPage />} />
            <Route path="volunteer-2" element={<VolunteerPageS2 />} />
            <Route path="volunteer-single/:slug" element={<TeamSinglePage />} />
            <Route path="project" element={<ProjectPage />} />
            <Route path="project-single/:slug" element={<ProjectSingle />} />
            <Route path="donate" element={<DonatePage />} />
            <Route path="wall-of-akhirah" element={<WallOfAkhirah />} />
            <Route path="shop" element={<ShopPage />} />
            <Route path='shop-single/:slug' element={<ProductSinglePage />} />
            <Route path='cart' element={<CartPage />} />
            <Route path='checkout' element={<CheckoutPage />} />
            <Route path='order_received' element={<OrderRecived />} />
            <Route path='contact' element={<ContactPage />} />
            <Route path='404' element={<ErrorPage />} />
            <Route path='admin' element={<AdminLogin />} />
            <Route path='admin/callback' element={<AdminLogin />} />
            <Route path='admin/dashboard' element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path='admin/services/:id' element={<ProtectedRoute><AdminServiceEditor /></ProtectedRoute>} />
            <Route path='admin/events/:id' element={<ProtectedRoute><AdminEventEditor /></ProtectedRoute>} />
            <Route path='admin/blogs/:id' element={<ProtectedRoute><AdminBlogEditor /></ProtectedRoute>} />
            <Route path='admin/volunteers/:id' element={<ProtectedRoute><AdminVolunteerEditor /></ProtectedRoute>} />
          </Routes>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
